import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Landscaping;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Landscaping.Phaser.IntroductionScene.1",
            "Landscaping.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/scenes/GameIntro.ts